import { MinigridArchitecture, MinigridArchitectureDevice } from "../../../../types/minigridtypes";
import styles from "./LiveDashboardView.module.scss";

export interface ArchitecturePanelProps {
    architecture: MinigridArchitecture | null;
    isLoading?: boolean;
    error?: string | null;
}

/* ── Libellés humains par service_type Victron ────────────────────── */
const TYPE_LABEL: Record<string, string> = {
    battery: "Moniteur batterie",
    solar_charger: "Chargeur solaire (MPPT)",
    vebus: "Onduleur-chargeur (VE.Bus)",
    grid: "Réseau",
    genset: "Groupe électrogène",
    system: "Système",
    settings: "Réglages",
    pvinverter: "Onduleur PV",
    tank: "Réservoir",
    temperature: "Température",
};

function humanType(serviceType: string | undefined): string {
    if (!serviceType) return "Appareil";
    return TYPE_LABEL[serviceType] ?? serviceType;
}

export default function ArchitecturePanel({ architecture, isLoading, error }: ArchitecturePanelProps) {
    return (
        <div className={styles.archSection}>
            <div className={styles.archHeader}>
                Architecture détectée {architecture ? `(${architecture.devices.length} appareil${architecture.devices.length > 1 ? "s" : ""})` : ""}
            </div>
            {isLoading && <div className={styles.archLoading}>Détection en cours…</div>}
            {error && <div className={styles.archError}>{error}</div>}
            {architecture && architecture.devices.length === 0 && !isLoading && (
                <div className={styles.archEmpty}>Aucun appareil détecté sur ce CCGX.</div>
            )}
            {architecture && architecture.devices.length > 0 && (
                <div className={styles.archGrid}>
                    {architecture.devices.map((d) => (
                        <DeviceCard key={d.source} device={d} />
                    ))}
                </div>
            )}
        </div>
    );
}

function DeviceCard({ device }: { device: MinigridArchitectureDevice }) {
    const title = device.label || humanType(device.service_type);
    return (
        <div className={styles.archCard}>
            <div className={styles.archCardHeader}>
                <span className={styles.archCardTitle}>{title}</span>
                <span className={styles.archCardType}>{humanType(device.service_type)}</span>
            </div>
            <div className={styles.archCardMeta}>
                <span className={styles.archCardSource}>{device.source}</span>
                {device.connection && <span>{device.connection}</span>}
                {device.manufacturer && <span>{device.manufacturer}</span>}
                {device.firmware_version && <span>v{device.firmware_version}</span>}
            </div>
        </div>
    );
}
